<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				
				<a-button class="qinang-button-margin" icon="plus" @click="handleBind">设备绑定</a-button>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiCheckDeviceQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="准进设备查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">设备名称：</div>
						<a-input v-model="query.checkdeviceName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiCheckDeviceQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						[{{mainNavigation[0].facilitatorName}}] 设备列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="checkdeviceId" :loading="tableLoading" :pagination="false">
				<span slot="checkdeviceName" slot-scope="checkdeviceName">
					<a-button type="link" @click="edit(checkdeviceName)" >{{checkdeviceName.checkdeviceName}}</a-button>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{mainNavigation[0].facilitatorName}}
				</span>
				<span slot="ticketwindowState" slot-scope="ticketwindowState">
					<span v-if="ticketwindowState == 2">禁用</span>
					<span v-if="ticketwindowState == 3">启用</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="salewindowManage(tableAction)">检票权限</a-button>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="设备名称" has-feedback prop="checkdeviceName">
					<a-input v-model="addForm.checkdeviceName" placeholder="请输入设备名称" />
				</a-form-model-item>
				<a-form-model-item label="所属服务商" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" placeholader="请选择服务商" @change="addSelectFacilitator">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="所属园门" has-feedback prop="checkstationId">
					<a-select v-model="addForm.checkstationId" placeholader="请选择园门" >
						<a-select-option v-for="(item,index) in checkstation" :value="item.checkstationId" :key="index">{{item.checkstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="MAC地址" has-feedback prop="mac">
					<a-input v-model="addForm.mac" placeholder="请输入MAC地址" />
				</a-form-model-item>
				<a-form-model-item label="设备位置" has-feedback prop="enterOut">
					<a-radio-group name="enterOut" v-model="addForm.enterOut">
						<a-radio :value="1">入口设备</a-radio>
						<a-radio :value="0">出口设备</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="第三方设备编号" has-feedback prop="strTESn">
					<a-input v-model="addForm.strTESn" placeholder="请输入第三方设备编号" />
				</a-form-model-item>
				<a-form-model-item label="阶梯分账账户" has-feedback prop="ladderAccount">
					<a-input v-model="addForm.ladderAccount" placeholder="请输入阶梯分账账户" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="checkdeviceState">
					<a-radio-group name="checkdeviceState" v-model="addForm.checkdeviceState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="设备名称" has-feedback prop="checkdeviceName">
					<a-input v-model="editForm.checkdeviceName" placeholder="请输入设备名称" />
				</a-form-model-item>
				<a-form-model-item label="所属服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" @change="editSelectFacilitator" >
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="所属园门" has-feedback prop="checkstationId">
					<a-select v-model="editForm.checkstationId" >
						<a-select-option v-for="(item,index) in checkstation" :value="item.checkstationId" :key="index">{{item.checkstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="MAC地址" has-feedback prop="mac">
					<a-input v-model="editForm.mac" placeholder="请输入MAC地址" />
				</a-form-model-item>
				<a-form-model-item label="设备位置" has-feedback prop="enterOut">
					<a-radio-group name="enterOut" v-model="editForm.enterOut">
						<a-radio :value="1">入口设备</a-radio>
						<a-radio :value="0">出口设备</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="第三方设备编号" has-feedback prop="strTESn">
					<a-input v-model="editForm.strTESn" placeholder="请输入第三方设备编号" />
				</a-form-model-item>
				<a-form-model-item label="阶梯分账账户" has-feedback prop="ladderAccount">
					<a-input v-model="editForm.ladderAccount" placeholder="请输入阶梯分账账户" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="checkdeviceState">
					<a-radio-group name="checkdeviceState" v-model="editForm.checkdeviceState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal class="qa-modal" width="100%"  title="订单详情" :visible="bindVisible" @ok="bindVisible=false" @cancel="bindVisible=false" :maskClosable="false" :keyboard="false">
			<check-device-bind style="width: 100%;" v-if="bindVisible"  @success="apiCheckDeviceQueryList"></check-device-bind>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment'
	import CheckDeviceBind from './CheckDeviceBind.vue';
	export default {
		components: {
			CheckDeviceBind,
		},
		data() {
			return {
				moment,
				bindVisible: false,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//服务商列表
				facilitatorList: [],
				//园门列表
				checkstation: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					checkdeviceName: '',
				},
				mainNavigation:[ {facilitatorName: ''} ],
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'checkdeviceId', key:'checkdeviceId', align:'center'},
					{ title:'设备名称', key:'checkdeviceName', align:'center', scopedSlots:{customRender:'checkdeviceName'}},
					{ title:'所属服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'所属园门', key:'checkstationName', dataIndex:'checkstationName', align:'center'},
					{ title:'MAC地址', key:'tel', dataIndex:'mac',align:'center'},
					{ title:'状态', dataIndex:'checkdeviceState', key:'checkdeviceState', align:'center', scopedSlots:{customRender:'ticketwindowState'}},
					{ title: '操作', key: 'tableAction', align: 'center', scopedSlots: { customRender: 'tableAction' } },
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					checkdeviceName: '',
					facilitatorId: undefined,
					checkstationId: undefined,
					mac: '',
					enterOut:1,
					strTESn:'',
					ladderAccount:'',
					checkdeviceState: 3,
					remarks: '',
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					checkstationId: [{ required: true, message: '请选择园门', trigger: 'blur' }],
					checkdeviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
					// checkdeviceState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					checkdeviceId: '',
					checkdeviceName: '',
					facilitatorId: undefined,
					checkstationId: undefined,
					mac: '',
					enterOut:1,
					strTESn:'',
					ladderAccount:'',
					checkdeviceState: 3,
					remarks: '',
				},
				// 修改弹窗-end
				
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiCheckDeviceQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取园门列表
			async apiCheckstationList(id) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationList,{'facilitatorId':id});
				if (res.code == 200) {
					this.checkstation = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			//添加弹窗服务商下拉框
			addSelectFacilitator(e){
				this.addForm.checkstationId = undefined
				this.apiCheckstationList(e)
			},

			//表格开始-搜索
			async apiCheckDeviceQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCheckDeviceQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCheckDeviceQueryList()
			},
			tableAdd(){
				this.addForm = {
					checkdeviceName: '',
					facilitatorId: undefined,
					checkstationId: undefined,
					mac: '',
					enterOut:1,
					strTESn:'',
					ladderAccount:'',
					checkdeviceState: 3,
					remarks: '',
				}
				this.addVisible = true
			},
			async apiCheckDeviceAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiCheckDeviceQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiCheckDeviceAdd()
					} else {
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
				this.apiCheckstationList(item.checkstationId)
				this.editVisible = true
			},
			editSelectFacilitator(e){
				this.editForm.checkstationId = undefined
				this.apiCheckstationList(e)
			},
			async apiCheckDeviceEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiCheckDeviceQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCheckDeviceEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.checkdeviceId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.checkdeviceName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiCheckDeviceDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiCheckDeviceDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckDeviceDel, {checkdeviceId: this.tableSelectedRows.checkdeviceId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiCheckDeviceQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.checkdeviceId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			//销售权限
			salewindowManage(e){
				let saleCheckDeviceManageMain = []
				saleCheckDeviceManageMain[0] = {'facilitatorId': this.mainNavigation[0].facilitatorId, 'facilitatorName': this.mainNavigation[0].facilitatorName}
				saleCheckDeviceManageMain[1] = {'checkstationId': e.checkstationId, 'checkstationName': e.checkstationName}
				saleCheckDeviceManageMain[2] = {'checkdeviceId': e.checkdeviceId, 'checkdeviceName': e.checkdeviceName}
				window.sessionStorage.setItem("saleCheckDeviceManageMain", JSON.stringify(saleCheckDeviceManageMain))
				console.log(window.sessionStorage.getItem("saleCheckDeviceManageMain"));
				this.$router.push('/SaleCheckDevice')
			},
			handleBind(){
				this.bindVisible = true
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
